import { GridList } from '@material-ui/core';
import styled from 'styled-components';
import Colors from '../../constants/color';

export const ContainerExt = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  margin: 16px;
  border-radius: 6px;
`;
export const ContainerList = styled(GridList)`
  display: flex;
  justify-content: center;
`;
export const CardSearch = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 28px;
`;

export const Footer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: flex-end;

  div {
    width: 200px;
  }
`;
export const ContainerPagination = styled.div`
  display: flex;
  justify-content: center;

`;
export const ContainerLoading = styled.div`
  display: flex;
  justify-content: center;`;

export const ContainerFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
`;
export const ContainerSelect = styled.div`
  display: flex;
  flex-direction: column;
  
  strong {
    margin-left: 2px
  }
`;
export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 4px;
  align-items: flex-end;
  justify-content: center;
`;
export const SelectRadius = styled.div`
  display: flex;
  justify-content: center;
  height: 50px;
  border-radius: 30px;
  width: 200px;
  margin-top: 15px;
  border: 1px solid ${Colors.grey8};

  select {
    width: 80%;
    padding: 0px 11px 0px 4px;
    border: none;
    outline: none;
    background-color: transparent;
  }
`;

export const Strong = styled.strong`
  font-size: 14px;
  font-family: 'Graphik-Semibold';
  color: ${Colors.grey1};
`;
export const Option = styled.option`
  font-size: 14px;
  font-family: 'Graphik-Regular';
  color: ${Colors.grey1};
`;
export const SizedBox = styled.div`
  width: 10px;
`;
export const IsEmpity = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-family: 'Graphik-Regular';
`;
